import DeleteIcon from '@mui/icons-material/DeleteOutlined'
import EditIcon from '@mui/icons-material/Edit'
import { Popover } from '@mui/material'
import React, { useCallback } from 'react'

import { Box, ButtonBase, GridMoreVertIcon } from '../../../../../components'
import { styled } from '../../../../../theme'

interface ActionsCellMenuProps {
  id: string
  editCallBack?: (id: string) => void
  deleteCallback?: (id: string) => void
}

// eslint-disable-next-line import/no-unused-modules
export const ActionsCellMenu = ({ id, editCallBack, deleteCallback }: ActionsCellMenuProps) => {
  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null)

  const handleClick = useCallback((event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget)
  }, [])

  const handleClose = useCallback(() => {
    setAnchorEl(null)
  }, [])

  const open = Boolean(anchorEl)
  const anchorId = open ? `row-actions-menu-${id}` : undefined

  const StyledButtonBase = styled(ButtonBase)`
    width: 100%;
    display: flex;
    justify-content: start;
    gap: 8px;
    p {
      color: #000c;
      text-transform: unset;
      margin: 0;
      padding: 0;
    }
  `

  const StyledBox = styled(Box)`
    display: flex;
    align-items: start;
    flex-direction: column;
    padding: 5px;
  `

  return (
    <Box>
      <ButtonBase
        data-test-id="row-action-button"
        data-actions-for={id}
        aria-describedby={anchorId}
        onClick={handleClick}
      >
        <GridMoreVertIcon />
      </ButtonBase>
      <Popover
        id={anchorId}
        open={open}
        onClose={handleClose}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
      >
        <StyledBox>
          <StyledButtonBase
            data-test-id="edit_row-action-button"
            onClick={() => {
              if (editCallBack) editCallBack(id)
            }}
          >
            <EditIcon />
            <p>Edit</p>
          </StyledButtonBase>
          <StyledButtonBase
            data-test-id="delete_row-action-button"
            onClick={() => {
              if (deleteCallback) deleteCallback(id)
            }}
          >
            <DeleteIcon />
            <p>Delete</p>
          </StyledButtonBase>
        </StyledBox>
      </Popover>
    </Box>
  )
}
